module.exports = __webpack_public_path__ + "static/media/example.bf091365.jpg";